module.exports = __webpack_public_path__ + "static/media/icon_arrow_up.bdfd8049.svg";